<div class="container">
  <ng-content></ng-content>
</div>

<mat-divider class="margin-bottom"></mat-divider>
